// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--7deb6";
export var hidden = "styles-module--hidden--6c1a0";
export var swiper = "styles-module--swiper--3c58e";
export var wrapper = "styles-module--wrapper--8da92";